import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface TotalActiveClassesParams {
  filter?: 'current-month';
  sessionId: string;
}

interface TotalActiveClassesResponse {
  totalClassesEnrolled: number;
}

export const getTotalActiveClassesAPI = async (
  params: TotalActiveClassesParams,
) => {
  const response = await baseAPI.get<TotalActiveClassesResponse>(
    '/dashboard/metrics/active-classes/total',
    {
      params,
    },
  );
  return response.data;
};

export const useGetTotalActiveClasses = (params: TotalActiveClassesParams) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [
      KEYS.TOTAL_ACTIVE_CLASSES,
      params.sessionId,
      params.filter ?? '',
    ],
    queryFn: () => getTotalActiveClassesAPI(params),
    enabled: !!params.sessionId,
  });
};
